import { Center } from 'design-system'
import { ReactNode, useRef } from 'react'
import { useSelector } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { HelpButton } from 'src/components/navigation/get-help-launcher'
import useDocumentTitle from 'src/hooks/useDocumentTitle'
import { useDatadogUserObserver } from 'src/lib/datadog/use-datadog-user-observer'
import * as networkSelectors from 'src/store/selectors/network'

import { DEFAULT_GRADIENT_CLASS_NAME } from '../constants'
import { gradientSelector } from '../gradient-selector'

const mapStateToProps = createStructuredSelector({
  brandColor: networkSelectors.brandColorSelector
})

const mainId = 'main'

export default function GlobalLayout({
  title,
  subtitle,
  children,
  authenticated
}: {
  title: string
  subtitle?: string
  children: ReactNode
  authenticated?: boolean
}) {
  const layoutBase = useRef(null)
  const { brandColor } = useSelector(mapStateToProps)
  const bgGradient = brandColor && gradientSelector(brandColor)

  useDocumentTitle([title, subtitle].filter(Boolean).join(' - '))

  useDatadogUserObserver(authenticated)

  return (
    <div ref={layoutBase} className="flex h-full w-full flex-col lg:flex-row">
      <main id={mainId} className="h-full min-w-0 grow p-0">
        <div
          className={DEFAULT_GRADIENT_CLASS_NAME}
          role="presentation"
          aria-hidden="true"
          {...(bgGradient && {
            style: {
              background: bgGradient
            }
          })}
        />
        <Center
          horizontalGaps={4}
          className="flex h-full max-w-prose flex-col 2xl:px-8">
          <div className="h-full py-4 2xl:py-8">{children}</div>
        </Center>
      </main>
      <HelpButton />
    </div>
  )
}
